import { attachMenuSounds } from './MenuSounds';

export interface PauseHandlers {
  onResume: () => void;
  onReset: () => void;
  onLeaderboard: () => void;
  onSettings: () => void;
  onQuitToTitle: () => void;
}

export class PauseScreen {
  readonly root: HTMLDivElement;

  constructor(parent: HTMLElement, handlers: PauseHandlers) {
    this.root = document.createElement('div');
    this.root.id = 'pause-screen';
    this.root.className = 'tst-screen tst-overlay';
    this.root.style.zIndex = '25';
    this.root.hidden = true;
    this.root.innerHTML = `
      <div class="tst-card">
        <div class="tst-title-sm">RUN HOLD</div>
        <div class="tst-buttons">
          <button data-action="resume" class="tst-btn tst-btn-primary">Resume Run</button>
          <button data-action="reset" class="tst-btn">Reset Lap</button>
          <button data-action="lb" class="tst-btn">Timing Board</button>
          <button data-action="settings" class="tst-btn">Systems</button>
          <button data-action="quit" class="tst-btn tst-btn-ghost">Return to Control</button>
        </div>
      </div>
    `;
    this.root.querySelector('[data-action="resume"]')!.addEventListener('click', handlers.onResume);
    this.root.querySelector('[data-action="reset"]')!.addEventListener('click', handlers.onReset);
    this.root.querySelector('[data-action="lb"]')!.addEventListener('click', handlers.onLeaderboard);
    this.root.querySelector('[data-action="settings"]')!.addEventListener('click', handlers.onSettings);
    this.root.querySelector('[data-action="quit"]')!.addEventListener('click', handlers.onQuitToTitle);
    attachMenuSounds(this.root);
    parent.appendChild(this.root);
  }

  show(): void { this.root.hidden = false; }
  hide(): void { this.root.hidden = true; }
  isOpen(): boolean { return !this.root.hidden; }
}
